import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { cn } from "@/lib/utils";
import { AddManualUserDialog } from "./AddManualUserDialog";
import { useRecepcionistaRedirect } from "@/hooks/useRecepcionistaRedirect";

interface UserListHeaderProps {
  gymId: string | null;
  className?: string;
  onUserAdded?: () => void;
  showAddUser?: boolean;
}

export const UserListHeader = ({ gymId, className, onUserAdded, showAddUser = true }: UserListHeaderProps) => {
  const navigate = useNavigate();
  const { isRecepcionista } = useRecepcionistaRedirect();

  const handleBack = () => {
    if (isRecepcionista) {
      navigate("/recepcionista");
    } else if (gymId) {
      navigate("/configuracion?tab=admin");
    } else {
      navigate("/configuracion?tab=admin&subtab=estadisticas");
    }
  };

  return (
    <div className={cn("mb-4 sm:mb-6 flex items-center justify-between", className)}>
      <Button
        variant="ghost"
        className="w-fit"
        onClick={handleBack}
      >
        <ArrowLeft className="mr-2 h-4 w-4" />
        {isRecepcionista ? "Volver al Panel" : "Volver"}
      </Button>
      {gymId && showAddUser && (
        <AddManualUserDialog gymId={gymId} onUserAdded={onUserAdded} />
      )}
    </div>
  );
};
